class LocalCache {
  setCache(key: string, value: any) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
  getCache(key: string) {
    const value = window.sessionStorage.getItem(key);
    if (value != undefined) {
      return JSON.parse(value);
    }else {
      return '';
    }
  }
  deleteCache(key: string) {
    window.sessionStorage.removeItem(key);
  }
  clearCache() {
    window.sessionStorage.clear();
  }
}

export default new LocalCache();
